import './core';

export * from './builders/contact_builder';
export * from './builders/resource_builder';
export * from './builders/resource_category_builder';
export * from './builders/resource_info_builder';
export * from './builders/resource_location_builder';

export * from './datasources/resource_category_datastore';
export * from './datasources/resource_datastore';
export * from './datasources/resource_info_datastore';
export * from './datasources/resource_location_datastore';

export * from './servants/resource_list_servant';
export * from './builders/resource_detail_builder';
export * from './queries/resource_category_query';
export * from './queries/resource_list_query';

export * from './datasources/contacts_datastore';
export * from './services/contact_service';
export * from './services/contact_toggle_service';
export * from './services/contact_list_service';
export * from './services/contact_search_service';
export * from './services/resource_search_service';
export * from './queries/contacts_relationship_query';
export * from './queries/contacts_list_query';
export * from './queries/contacts_search_query';
export * from './queries/resource_search_query';
export * from './contact_interfaces';
export * from './resources_interface';
export * from './types/resource_tab_enum';
export * from './models/contacts_search_model';
export * from './models/resource_search_model';

export const resources = 'capability-ng-resources';



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-resources/src/main.ts